import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={60}
      height={60}
      viewBox="0 0 60 60"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle opacity={0.1} cx={30} cy={30} r={30} fill="#00AB59" />
      <Circle opacity={0.5} cx={30} cy={30} r={24} fill="#00AB59" />
      <Circle cx={30} cy={30} r={18} fill="#00AB59" />
      <Path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.291 22.147a1.8 1.8 0 01-.039 2.545l-12.375 12a1.8 1.8 0 01-2.506 0l-5.625-5.454a1.8 1.8 0 012.506-2.585l4.372 4.24 11.122-10.785a1.8 1.8 0 012.545.039z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
